import { ColorProps } from '@chakra-ui/react'
import { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'

import {
  addToastAction,
  removeToastAction,
} from '../components/Toaster/Redux/actions'
import { ToastType } from '../components/Toaster/Toaster'

export const useToaster = (defaultTimeout?: number) => {
  const dispatch = useDispatch()

  return useMemo(
    () => ({
      removeToast: (toast: ToastType) => dispatch(removeToastAction(toast)),
      showErrorToast: (
        message: string | React.ReactElement,
        timeout: number | undefined = defaultTimeout,
      ) =>
        dispatch(
          addToastAction({
            color: 'violet.90',
            message,
            timeout,
          }),
        ),
      showSuccessToast: (
        message: string | React.ReactElement,
        timeout: number | undefined = defaultTimeout,
      ) => dispatch(addToastAction({ color: 'green.50', message, timeout })),
      showToast: (
        message: string | React.ReactElement,
        color: ColorProps['color'],
        timeout: number | undefined = defaultTimeout,
      ) => dispatch(addToastAction({ color, message, timeout })),
    }),
    [dispatch, defaultTimeout],
    // dispatch is the same ref as long as it is the same store
  )
}

export const useErrorToast = (
  message: string | React.ReactElement,
  options: {
    enabled: boolean
    timeout?: number
  },
) => {
  const { showErrorToast } = useToaster(options.timeout)

  useEffect(() => {
    if (options.enabled === false) return

    showErrorToast(message, options.timeout)
  }, [options.enabled, showErrorToast, message, options.timeout])
}
